export {default as App} from 'containers/App';
export {default as BulkResize} from 'containers/BulkResize';
export {default as PdfResize} from 'containers/PdfResize';
export {default as PdfCompressor} from 'containers/PdfCompressor';
export {default as CompressImages} from 'containers/CompressImages';
export {default as Contact} from 'containers/Contact';
export {default as Features} from 'containers/Features';
export {default as Help} from 'containers/Help';
export {default as Log} from 'containers/Log';
export {default as Delete} from 'containers/Delete';
export {default as ImageResize} from 'containers/ImageResize';
export {default as NotFound} from 'containers/NotFound';
export {default as Privacy} from 'containers/Privacy';
export {default as TermsOfService} from 'containers/TermsOfService';
export {default as ViewImage} from 'containers/ViewImage';



// WEBPACK FOOTER //
// ./src/containers/index.js